import { ERROR_ACTION, WAIT_FOR_ACTION } from "redux-wait-for-action";

export const actionTypes = {
    AUDIT_BULK_ABANDONED_CLOSE_FAILURE: "AUDIT_BULK_ABANDONED_CLOSE_FAILURE",
    AUDIT_BULK_ABANDONED_CLOSE_REQUEST: "AUDIT_BULK_ABANDONED_CLOSE_REQUEST",
    AUDIT_BULK_ABANDONED_CLOSE_SUCCESS: "AUDIT_BULK_ABANDONED_CLOSE_SUCCESS",

    AUDIT_CLOSE_FAILURE: "AUDIT_CLOSE_FAILURE",
    AUDIT_CLOSE_REQUEST: "AUDIT_CLOSE_REQUEST",
    AUDIT_CLOSE_SUCCESS: "AUDIT_CLOSE_SUCCESS",

    AUDIT_ITEM_CLEAR: "AUDIT_ITEM_CLEAR",
    AUDIT_ITEM_SET: "AUDIT_ITEM_SET",

    AUDIT_PATCH_FAILURE: "AUDIT_PATCH_FAILURE",
    AUDIT_PATCH_REQUEST: "AUDIT_PATCH_REQUEST",
    AUDIT_PATCH_SUCCESS: "AUDIT_PATCH_SUCCESS",

    AUDITS_CLEAR: "AUDITS_CLEAR",

    AUDITS_GET_FAILURE: "AUDITS_GET_FAILURE",
    AUDITS_GET_REQUEST: "AUDITS_GET_REQUEST",
    AUDITS_GET_SUCCESS: "AUDITS_GET_SUCCESS",

    AUDITS_POST_FAILURE: "AUDITS_POST_FAILURE",
    AUDITS_POST_REQUEST: "AUDITS_POST_REQUEST",
    AUDITS_POST_SUCCESS: "AUDITS_POST_SUCCESS",

    AUDITS_SET: "AUDITS_SET"
};

export const actionCreators = {
    clear: () => ({
        type: actionTypes.AUDITS_CLEAR
    }),

    bulkAbandonedCloseRequest: (auditIds: number[]) => ({
        type: actionTypes.AUDIT_BULK_ABANDONED_CLOSE_REQUEST,
        payload: { auditIds },
        [WAIT_FOR_ACTION]: actionTypes.AUDIT_BULK_ABANDONED_CLOSE_SUCCESS,
        [ERROR_ACTION]: actionTypes.AUDIT_BULK_ABANDONED_CLOSE_FAILURE
    }),
    bulkAbandonedCloseSuccess: () => ({
        type: actionTypes.AUDIT_BULK_ABANDONED_CLOSE_SUCCESS
    }),
    bulkAbandonedCloseFailure: (error) => ({
        type: actionTypes.AUDIT_BULK_ABANDONED_CLOSE_FAILURE,
        error
    }),

    closeRequest: (auditId: number) => ({
        type: actionTypes.AUDIT_CLOSE_REQUEST,
        payload: { auditId },
        [WAIT_FOR_ACTION]: actionTypes.AUDIT_CLOSE_SUCCESS,
        [ERROR_ACTION]: actionTypes.AUDIT_CLOSE_FAILURE
    }),
    closeSuccess: (audit: any) => ({
        type: actionTypes.AUDIT_CLOSE_SUCCESS,
        payload: { audit }
    }),
    closeFailure: (error) => ({
        type: actionTypes.AUDIT_CLOSE_FAILURE,
        error
    }),

    getRequest: (status: string) => ({
        type: actionTypes.AUDITS_GET_REQUEST,
        payload: status,
        [WAIT_FOR_ACTION]: actionTypes.AUDITS_GET_SUCCESS,
        [ERROR_ACTION]: actionTypes.AUDITS_GET_FAILURE
    }),
    getSuccess: (audits: any) => ({
        type: actionTypes.AUDITS_GET_SUCCESS,
        payload: { audits }
    }),
    getFailure: (error: Error) => ({
        type: actionTypes.AUDITS_GET_FAILURE,
        error
    }),

    itemClear: () => ({
        type: actionTypes.AUDIT_ITEM_CLEAR
    }),
    itemSet: (audit: any) => ({
        type: actionTypes.AUDIT_ITEM_SET,
        payload: { audit }
    }),

    patchRequest: (audit: any) => ({
        type: actionTypes.AUDIT_PATCH_REQUEST,
        payload: { audit },
        [WAIT_FOR_ACTION]: actionTypes.AUDIT_PATCH_SUCCESS,
        [ERROR_ACTION]: actionTypes.AUDIT_PATCH_FAILURE
    }),
    patchSuccess: (audit: any) => ({
        type: actionTypes.AUDIT_PATCH_SUCCESS,
        payload: { audit }
    }),
    patchFailure: (error) => ({
        type: actionTypes.AUDIT_PATCH_FAILURE,
        error
    }),

    postRequest: (audits: Array<any>) => ({
        type: actionTypes.AUDITS_POST_REQUEST,
        [WAIT_FOR_ACTION]: actionTypes.AUDITS_POST_SUCCESS,
        [ERROR_ACTION]: actionTypes.AUDITS_POST_FAILURE,
        payload: { audits }
    }),
    postSuccess: (audits: any) => ({
        type: actionTypes.AUDITS_POST_SUCCESS,
        payload: { audits }
    }),
    postFailure: (error: Error) => ({
        type: actionTypes.AUDITS_POST_FAILURE,
        error
    }),

    set: (audits: Array<any>) => ({
        type: actionTypes.AUDITS_SET,
        payload: { audits }
    })
};

export default {
    create: actionCreators,
    type: actionTypes
};
